import { PaymentWindowRequestCreditCardSpace } from 'src/types/api'
import { encryptPhoneNumber } from 'src/utils'
import { Bridge } from 'src/utils/bridge'
import { useChannel } from 'src/provider/ChannelContextProvider'
import { addFlowBreadcrumb } from 'src/utils/sentry/breadcrumbs'

const useDanal = () => {
  const { channel } = useChannel()

  const handleDanalPaymentReqeust = (
    props: PaymentWindowRequestCreditCardSpace.DanalRequest,
    isGift?: boolean,
  ) => {
    const { ITEM_NAME, AMOUNT, ORDER_ID, PayMethod } = props

    const danalRequestData = {
      itemName: `${ITEM_NAME?.slice(0, 20)}${ITEM_NAME?.length > 20 ? '...' : ''}`,
      amount: AMOUNT,
      orderId: ORDER_ID,
      payMethod: PayMethod,
    }
    const externalUrl = `${window.location.origin}/${channel}/danal/call?data=${encryptPhoneNumber(JSON.stringify(danalRequestData))}${!!isGift ? '&&isGift=true' : ''}`
    addFlowBreadcrumb('payment_attempt', 'request', {
      handler: 'handleDanalPaymentReqeust',
      channel: channel,
      payMethod: PayMethod,
      type: isGift ? 'gift' : 'default',
    })
    // web: window.open / aos·ios: 외부 브라우저 → finish 페이지에서 window.close() 가능
    Bridge.handleReqExternalOpenUrl(externalUrl)
  }

  return { handleDanalPaymentReqeust }
}

export default useDanal
